<template>
<div v-if="isLoading === false">
  <div id='slide' :style="{ backgroundImage: `url(${data.backgroundImage} )` }">
    <div :id=overlayID :style="{ backgroundImage: `linear-gradient(to bottom, ${this.getColorz()})` }">
    <div id="half_2nd" :style="{ backgroundImage: `linear-gradient(to bottom, ${this.getColorz()})` }"/>
    </div>
    <div id='logo'>
    </div>
    <div id='header'>
      EVENTS
    </div>
    <div id='info'>
        <p id='title'>{{data.title}}</p>
        <p id='description'>{{data.description}}</p>
    </div>
    <div id='footer'>
        <div class='footer_item'>
            <img src='../../public/img/event-slide-icons/calendar.png' />
            {{data.date}}
        </div>
        <div class='footer_item'>
            <img src='../../public/img/event-slide-icons/location.png' />
            {{data.eventLocation}}
        </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from "axios";

export default {
  name: "EventSlide",
  data() {
    return {
      isLoading: true,
      refreshTimer: null,
      data: null
    };
  },
  computed:{
    overlayID(){
      const {mode} = this.data
      
      if(mode === 'gradient')
        return 'overlay_full'
      else if(mode === 'half')
        return 'overlay_half'
      else if(mode === 'photo')
        return 'overlay_photo'
      return 'overlay_none'
    }
  },
  methods: {
    load() {
      const urlQuery = new URLSearchParams(window.location.search);

      if(!urlQuery.has('spid')){
        console.log("Missing Sedna Portal ID (spid) param.")
        return
      }
      
      // console.log(process.env.NODE_ENV)

      const url = process.env.NODE_ENV === 'development' ? `http://localhost:8000/api/cms/apps/${urlQuery.get('spid')}` : `https://sedna-cms.advent.zone/api/cms/apps/${urlQuery.get('spid')}`
            
      axios.get(url)
        .then(result => {
          const data = result.data.data
          this.data = data;
          this.isLoading = false;

          // console.log('app data', data)
        });
    },
    getColorz(){
      let colorTop;
      let colorBottom;
      
      const {colorScheme} = this.data;

      if(colorScheme === 'violet'){
        colorTop = '#4C1891' 
        colorBottom = '#2F0E5B'
      }
      else if(colorScheme === 'blue'){
        colorTop = '#002C89' 
        colorBottom = '#001B55' 
      }
      else if(colorScheme === 'turquoise'){
        colorTop = '#00AFC4' 
        colorBottom = '#008698'
      }
      else{
        colorTop = '#CD3E79' 
        colorBottom = '#902B6B' 
      }

      return [colorTop, colorBottom]
    }
  },
  created() {
    window.axios = axios
    this.load();
    this.refreshTimer = setInterval(this.load, 30 * 60 * 1000); // refresh news every 30 mins
  }
};
</script>

<style scoped>


#slide { 
  color: white;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: 100% 100%;
  width: 100vw;
  height: 100vh;
  font-size: 3vh;
}

#overlay_full {
  width:100%;
  height:100%;
}

#overlay_half {
  position: absolute;
  left: 0%;
  width:50%;
  height:100%;
  opacity:0.9;
}
#overlay_half #half_2nd{
  position: fixed;
  left: 49%;
  width:50%;
  height:100%;
  opacity:0.28;
}

#overlay_photo {
  width:100%;
  height: 100%;
  opacity:0.28;
}

#overlay_none {
  visibility: hidden;
}

#logo {
    position: fixed;
    top: 5%;
    left: 5%;
    background-image: url('../../public/img/are_logo.svg');
    background-repeat: no-repeat;
    background-size: contain;
    width: 50%;
    height: 10%;
}

#header {
    position: fixed;
    top: 13%;
    left: 5%;
    width: 50%;
    height: 20%;
    font-size: 20vh;
    font-weight: 300;
}

#info {
    position: absolute;
    left: 5%;
    right: 5%;
    top: 50%;
}

#title {
  font-size: 8vh;
  font-weight: 600;
  margin-top: 4vh;
  margin-bottom: 0;
}

#description {
  font-size: 3vh;
  font-weight: 100;
  margin-top: 2vh;
  margin-bottom: 0;
}

#footer {
    position: absolute;
    left: 5%;
    bottom: 1%;
    height: 10%;
    width:90%;
    font-size: 4vh;
    font-weight: 100;
}

.footer_item {
    display: inline;
    padding-right: 2%;
}

img {
    max-width: 70%;
    max-height: 70%;
    vertical-align:middle;
}
  
</style>
